import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {TrashOutlineIcon, TrashOutlineIconWhite} from "./IconButtons";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description: Action button component.
 * @param String id: Button identifier (required).
 * @param String name: Name of the model that receives the button (required).
 * @param String className: Style class for the button (optional).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param event onClick: Click event (required).
 * @param String url: Navigation URL (optional).
 * @param {JSX.Element} Icon: Icon component (optional).
 * @param Boolean splitName: If true, it separates the name into multiple lines (optional).
 * @param String iconProps: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @param Object state: Optional state to pass to the next route
 * @param String extraClassName: Additional class for the button, The additional class controls the height of the button (optional).
 * @returns {JSX.Element}
 */
const ButtonAction = (props) => {
    const {
        id = 'btn_ba_action',
        name,
        className = '',
        disabled = false,
        onClick = null,
        url = '',
        Icon,
        splitName = true,
        iconProps = 'btn-icon-svg-20px btn-icon-svg-white',
        iconPropsDisabled = 'btn-icon-svg-20px',
        state = null,
        iconClass= 'mr-1',
        extraClassName="btn-icon-svg-general"
    } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <button
            id={id}
            className={`btn-icon-svg ${extraClassName} flex-row ${className}`}
            disabled={disabled}
            onClick={(e) => {
                if (onClick !== null) onClick(e);

                if (url !== '') {
                    if (state !== null && state !== undefined) {
                        navigate(url, { state });
                    } else {
                        navigate(url);
                    }
                }
            }}
        >
            {Icon
                ? (disabled)
                    ? <Icon className={`${iconClass} ${iconPropsDisabled}`} />
                    : <Icon className={`${iconClass} ${iconProps}`} />
                : null
            }
            {splitName
                ? t(name).split(' ').map((word, index) => (
                    <React.Fragment key={index}>
                        {word} <br />
                    </React.Fragment>
                ))
                : t(name)
            }
        </button>
    );
};

export default ButtonAction;
